<div class="header" [class.app-mode-header]="appModeService.isApp()">
  <div class="header-top-row bg-white d-flex justify-content-between align-items-center px-2 px-sm-5 py-2">
    <img src="assets/img/logo.svg" class="logo" routerLink="/home" />
    <button
      *ngIf="appModeService.isApp()"
      type="button"
      class="app-menu-btn"
      aria-label="Open menu"
      (click)="openAppMenu()"
    >
      <span></span>
      <span></span>
      <span></span>
    </button>
  </div>

  <div *ngIf="appModeService.isApp() && isAppMenuOpen" class="app-side-overlay" (click)="closeAppMenu()"></div>
  <aside *ngIf="appModeService.isApp() && isAppMenuOpen" class="app-side-menu" (click)="$event.stopPropagation()">
    <div class="app-side-top">
      <div class="app-side-brand">
        <img src="assets/img/logo.svg" alt="WEMBLE" />
      </div>
      <button type="button" class="app-side-close" (click)="closeAppMenu()" aria-label="Close menu">
        <i class="pi pi-times"></i>
      </button>
    </div>

    <nav class="app-side-links">
      <button type="button" (click)="navigateFromAppMenu('home')">{{ 'MENU.HOME' | translate }}</button>
      <button type="button" (click)="navigateFromAppMenu('about')">{{ 'FOOTER.ABOUT_US' | translate }}</button>
      <button type="button" (click)="toggleAppLanguages()">{{ 'APP.LANGUAGES' | translate }}</button>
      <button type="button" (click)="navigateFromAppMenu('privacy')">{{ 'FOOTER.PRIVACY' | translate }}</button>
      <button type="button" (click)="navigateFromAppMenu('t&c')">{{ 'FOOTER.TERMS' | translate }}</button>

      <div class="app-side-lang-list" *ngIf="showAppLangOptions">
        <button
          type="button"
          *ngFor="let lang of availableLangs"
          [class.active]="selectedLang === lang.code"
          (click)="onAppLanguageSelect(lang.code)"
        >
          {{ lang.label }}
        </button>
      </div>
    </nav>

    <div class="app-side-contact">
      <a *ngIf="whatsappNumber" class="app-contact-link" [href]="whatsappUrl" target="_blank" rel="noopener noreferrer">
        {{ whatsappNumber }}
      </a>
      <a *ngIf="email" class="app-contact-link" [href]="'mailto:' + email">
        {{ email }}
      </a>
    </div>

    <div class="app-side-social">
      <a [href]="facebookUrl" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
        <i class="bi bi-facebook"></i>
      </a>
      <a [href]="xUrl" target="_blank" rel="noopener noreferrer" aria-label="X">
        <i class="bi bi-twitter-x"></i>
      </a>
      <a [href]="instaUrl" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
        <i class="bi bi-instagram"></i>
      </a>
      <a [href]="whatsappUrl" target="_blank" rel="noopener noreferrer" aria-label="WhatsApp">
        <i class="bi bi-whatsapp"></i>
      </a>
    </div>

    <div class="app-side-actions">
      <a class="app-catalog-btn" [href]="catalogueUrl" download>{{ 'MENU.DOWNLOAD_CATALOGUE' | translate }}</a>
    </div>
  </aside>

  <div *ngIf="appModeService.isApp() && showLoginModal" class="app-login-overlay" (click)="closeLoginModal()">
    <div class="app-login-modal" (click)="$event.stopPropagation()">
      <h3>Login</h3>
      <input type="email" [(ngModel)]="loginEmail" placeholder="Email" />
      <input type="password" [(ngModel)]="loginPassword" placeholder="Password" />
      <p *ngIf="loginError" class="app-login-error">{{ loginError }}</p>
      <button type="button" class="app-login-submit" (click)="submitLogin()">Submit</button>
      <button type="button" class="app-login-close" (click)="closeLoginModal()">Close</button>
    </div>
  </div>

  <p-menubar *ngIf="!appModeService.isApp()" [model]="menuItems" class="menubar-custom">
    <ng-template pTemplate="end">
      <div id="downloadCatalogButton" class="d-flex align-items-center gap-3 flex-nowrap">

        <a class="btn p-1 d-none d-md-inline" [href]="catalogueUrl" download>
          {{ 'MENU.DOWNLOAD_CATALOGUE' | translate }}
        </a>
        <div class="currency-dropdown" (click)="toggleCurrencyDropdown($event)">
          <i class="pi pi-wallet"></i>
          <span class="ms-2">{{ selectedCurrency }}</span>

          <div class="currency-menu" *ngIf="showCurrencyDropdown">
            <button *ngFor="let c of currencyOptions" (click)="onCurrencyChange(c)" class="currency-option">
              <span>{{ currencySymbols[c] }}</span>
            </button>
          </div>
        </div>

        <div class="lang-dropdown" (click)="toggleLangDropdown($event)">
          <i class="pi pi-globe text-lg"></i>
          <span class="fi" [ngClass]="currentLangFlag"></span>
          <span class="mt-1 ms-2">{{ selectedLang.toUpperCase() }}</span>

          <div class="lang-menu" *ngIf="showLangDropdown">
            <button *ngFor="let lang of availableLangs" (click)="onLanguageChange(lang.code)" class="lang-option">
              <span class="fi" [ngClass]="'fi-' + lang.flag"></span>
              {{ lang.label }}
            </button>
          </div>
        </div>

      </div>
    </ng-template>

  </p-menubar>
</div>
